import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import ReduxThunk from 'redux-thunk'
import searchReducer from 'components/Search/searchReducer'
import managerReducer from 'components/FormManager/FormManagerReducer'
import wizardReducer from 'components/Wizard2/WizardReducer'
import designerReducer from 'components/Designer2/DesignerReducer'
import formsReducer from 'components/Forms/FormsReducer'
import MyRecordsReducer from 'components/MyRecords/MyRecordsReducer'
import MyReceiptsReducer from './components/MyReceipts/MyReceiptsReducer'
import MyWorkQueueReducer from 'components/MyWorkQueue/MyWorkQueueReducer'
import HomeReducer from 'components/Home/HomeReducer'
import AuthReducer from './Auth/AuthReducer'
import AppSettingsReducer from 'components/AppSettings/AppSettingsReducer'
import AppSettingTypesReducer from 'components/AppSettings/AppSettingTypesReducer'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import rfl, { engine as rfe } from 'components/Wizard2/resolveFieldLogic'
import ls from 'local-storage'

export const resolveFieldLogic = rfl
export const resolveFieldEngine = rfe
export const history = createBrowserHistory()
const routeMiddleware = routerMiddleware(history)
const connectedRouter = connectRouter(history)
const DEPRECATE_IE = process.env.DEPRECATE_IE
const DEPRECATE_NON_CHROMIUM_EDGE = process.env.DEPRECATE_NON_CHROMIUM_EDGE

const getIsUnsupportedBrowser = () => {
  const checks = []
  if (DEPRECATE_IE) {
    checks.push(!!window.MSInputMethodContext && !!document.documentMode)
  }
  if (DEPRECATE_NON_CHROMIUM_EDGE) {
    checks.push(navigator.userAgent.indexOf('Edge') !== -1)
  }
  return checks.length ? checks.some((x) => x) : false
}

let initialState = {
  sidebarCollapsed: false,
  isMobile: document.body.clientWidth < 600 ? true : false,
  sidebarShown: false,
  overrideSidebarResizing: false,
  showLogin: false,
  appError: false,
  toastError: '',
  toastSuccess: '',
  toastIsPersistent: false,
  appSettings: {},
  currentCategory: '',
  cartQuantity: 0,
  isUnsupportedBrowser: getIsUnsupportedBrowser(),
  announcerMessages: [],
  stateUser: false,
}

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_APP_STATE':
      return initialState
    case 'TOGGLE_SIDEBAR_COLLAPSE':
      return { ...state, sidebarCollapsed: action.collapse }
    case 'TOGGLE_MOBILE_STATE':
      return { ...state, isMobile: action.isMobile }
    case 'TOGGLE_SIDEBAR_SHOW':
      return { ...state, sidebarShown: action.sidebarShown }
    case 'OVERRIDE_SIDEBAR_RESIZING':
      return { ...state, overrideSidebarResizing: action.overrideSidebarResizing }
    case 'TOGGLE_SHOW_LOGIN':
      return { ...state, showLogin: action.showLogin }
    case 'SET_STATE_USER':
      return { ...state, stateUser: action.stateUser }
    case 'SET_APP_ERROR':
      return {
        ...state,
        appError: {
          type: action.errorType,
          error: action.error,
          show: action.show === false ? false : true,
        },
      }
    case 'CLEAR_APP_ERROR':
      return { ...state, appError: false }
    case 'SET_APP_SETTINGS':
      return { ...state, appSettings: action.appSettings }
    case 'SET_ERROR_TOAST':
      return { ...state, toastError: action.error, toastIsPersistent: action.isPersistent || false }
    case 'CLEAR_ERROR_TOAST':
      return { ...state, toastError: '', toastIsPersistent: false }
    case 'SET_SUCCESS_TOAST':
      return { ...state, toastSuccess: action.success }
    case 'CLEAR_SUCCESS_TOAST':
      return { ...state, toastSuccess: '' }
    case 'SET_OFFLINE':
      return {
        ...state,
        appSettings: { ...action.appSettings, WEBSITE_PORTAL_OFFLINE_YN: action.offline },
      }
    case 'SET_CURRENT_CATEGORY':
      const userCache = ls.get('USER_CACHE') || {}
      const auth = store.getState().auth
      if (auth.loggedIn) {
        ls.set('USER_CACHE', { ...userCache, [auth.WEB_USER_ID]: action.category })
      }
      return { ...state, currentCategory: action.category }
    case 'SET_CART_QUANTITY':
      return { ...state, cartQuantity: action.quantity }
    case 'CLEAR_CART_QUANTITY':
      return { ...state, cartQuantity: 0 }
    case 'SET_UNSUPPORTED_BROWSER':
      return { ...state, isUnsupportedBrowser: action.isUnsupportedBrowser }
    case 'ANNOUNCE':
      return { ...state, announcerMessages: [...state.announcerMessages, action.message] }
    default:
      return state
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

let store = createStore(
  combineReducers({
    router: connectedRouter,
    app: appReducer,
    search: searchReducer,
    formManager: managerReducer,
    forms: formsReducer,
    wizard: wizardReducer,
    designer: designerReducer,
    myRecords: MyRecordsReducer,
    myReceipts: MyReceiptsReducer,
    queue: MyWorkQueueReducer,
    auth: AuthReducer,
    home: HomeReducer,
    appSettings: AppSettingsReducer,
    appSettingTypes: AppSettingTypesReducer,
  }),
  composeEnhancers(applyMiddleware(ReduxThunk, routeMiddleware))
)

export default store



// WEBPACK FOOTER //
// ./src/store.js